import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowRight,
	faCheck,
} from "@fortawesome/free-solid-svg-icons";

const CTASection: React.FC = () => {
	return (
		<section className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 dark:from-blue-900 dark:via-blue-950 dark:to-indigo-950 relative overflow-hidden">
			{/* Decorative orbs */}
			<div className="absolute top-[-20%] right-[-10%] w-[50%] h-[80%] rounded-full blur-[100px] bg-white/[0.07] pointer-events-none" />
			<div className="absolute bottom-[-30%] left-[-5%] w-[40%] h-[60%] rounded-full blur-[80px] bg-indigo-400/10 pointer-events-none" />

			<div className="max-w-5xl mx-auto relative">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
					{/* Left - Text */}
					<div>
						<p className="text-sm font-medium tracking-widest uppercase text-blue-200/70 dark:text-blue-300/50 mb-4">
							For Artists & Organizers
						</p>
						<h2 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-6">
							チケット販売を、
							<br />
							もっとシンプルに。
						</h2>
						<p className="text-base sm:text-lg text-blue-100/70 dark:text-blue-200/40 leading-relaxed mb-8 max-w-md">
							販売手数料は完全無料。イベント作成から入場管理まで、必要な機能を一つのプラットフォームに。
						</p>

						{/* Benefits */}
						<div className="space-y-3.5 mb-10">
							{[
								"直感的で簡単な操作",
								"手数料完全無料でチケットを購入",
								"スマホ対応、いつでもどこでも",
							].map((text, i) => (
								<div key={i} className="flex items-center gap-3">
									<div className="flex-shrink-0 w-5 h-5 rounded-full bg-white/15 flex items-center justify-center">
										<FontAwesomeIcon icon={faCheck} className="text-blue-200 h-2.5 w-2.5" />
									</div>
									<p className="text-base text-blue-50/80">{text}</p>
								</div>
							))}
						</div>

						<div className="flex flex-col sm:flex-row gap-3">
							<Link
								to="/organizer/start"
								className="inline-flex items-center justify-center gap-2 bg-white text-blue-700 px-8 py-4 rounded-lg text-base font-medium hover:bg-blue-50 transition-colors"
							>
								<span>主催者として始める</span>
								<FontAwesomeIcon icon={faArrowRight} className="h-4 w-4" />
							</Link>
							<Link
								to="/organizer/start"
								className="inline-flex items-center justify-center gap-2 text-white/70 border border-white/20 px-8 py-4 rounded-lg text-base font-medium hover:bg-white/10 hover:text-white transition-colors"
							>
								<span>詳しく見る</span>
							</Link>
						</div>
					</div>

					{/* Right - Stats */}
					<div className="grid grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden">
						{[
							{ value: "0%", label: "購入手数料" },
							{ value: "QR", label: "電子チケット" },
							{ value: "SSL", label: "安全な決済" },
							{ value: "24h", label: "いつでも購入" },
						].map((stat, i) => (
							<div
								key={i}
								className="bg-white/[0.06] backdrop-blur-sm p-8 sm:p-10 text-center"
							>
								<div className="text-3xl sm:text-4xl font-bold text-white mb-1.5">
									{stat.value}
								</div>
								<div className="text-sm text-blue-200/50">
									{stat.label}
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default CTASection;
